import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty } from '../../Common/Common';

export default class IAQ_Monitoring_Settings extends Component {
	constructor(props) {
		super(props);

		this.point_list = window.app.state.point_list;

		let iaq_settings = {};

		if (!isEmpty(this.props.param.response)) {
			iaq_settings = JSON.parse(JSON.stringify(this.props.param.response));

			//if point does not exist in point_list, delete from iaq_settings.
			for (var key in iaq_settings) {
				if (iaq_settings.hasOwnProperty(key)) {
					if(iaq_settings[key].length > 0) {
						let index = iaq_settings[key].length;

						while(index--) {
							if(!this.point_list.hasOwnProperty(iaq_settings[key][index].id)){
								iaq_settings[key].splice(index, 1);
							}
						}
					}
				}

				//if room does not have any points, delete room
				if(iaq_settings[key].length <= 0) {
					delete iaq_settings[key];
				}
			}
		}

		this.state = {
			iaq_settings: iaq_settings
		}

		window.app.hideLoading();

		{/* iaq settings room data format */ }
		{/*
			"Bedroom": [{
					"id": "dmtr1-00001",
					"type": "co2",
					"threshold_yellow": 1000,
					"threshold_red": 1200
				},
				{
					"id": "dmtr1-00002",
					"type": "pm25",
					"threshold_yellow": 50,
					"threshold_red": 80
				},
				{
					"id": "dmtr1-00003",
					"type": "tvoc",
					"threshold_yellow": 100,
					"threshold_red": 150
				}
			],
			"Living Room": [{
					"id": "dmtr1-00004",
					"type": "co",
					"threshold_yellow": 1000,
					"threshold_red": 1200
				},
				{
					"id": "dmtr1-00005",
					"type": "temp",
					"threshold_yellow": 32,
					"threshold_red": 40
				},
				{
					"id": "dmtr1-00006",
					"type": "humi",
					"threshold_yellow": 75,
					"threshold_red": 90
				}
			]
		*/}
		{/* iaq settings room data format */ }
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleAddIAQ = () => {
		console.log(JSON.stringify(this.point_list));
		console.log(JSON.stringify(this.state.iaq_settings));
		//this.props.content_handler('Add_Edit_Scene', {scene_id: null, scenes: this.props.param.scenes, from: this.props.param.from});
		this.props.content_handler('Add_Edit_IAQ', { room_id: null, iaq_settings: this.state.iaq_settings });
	}

	handleEditRoom = (room_id) => {
		this.props.content_handler('Add_Edit_IAQ', { room_id: room_id, iaq_settings: this.state.iaq_settings });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let room_button_style = {
			cursor: 'pointer',
			width: this.props.width - 80,
			padding: '10px 20px',
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			textAlign: 'left',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('iaq_mon_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddIAQ}
					/>
					<div id='data' style={{ height: this.props.height - 140, paddingBottom: 60, overflow: 'auto' }}>
						{Object.keys(this.state.iaq_settings).map((room_name) => {
							return (
								<div style={room_button_style} onClick={() => this.handleEditRoom(room_name)}>
									<div style={{ display: 'inline-block', width: this.props.width - 90, marginLeft: 10, verticalAlign: 'top', paddingTop: 5, overflow: 'hidden', textOverflow: 'ellipsis' }}>
										<span style={{ whiteSpace: 'nowrap' }}>{room_name}</span>
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}